import {
	Component,
	OnInit,
	Input,
	ViewChild,
	ViewContainerRef,
	SimpleChange,
} from "@angular/core";
import { DocBar } from "../../core/vo/docBar";

@Component({
	selector: "app-logo-image",
	templateUrl: "./logo-image.directive.html",
	styleUrls: ["./logo-image.directive.css"],
})
export class LogoImageDirective implements OnInit {
	@Input() logoData: DocBar;
	@ViewChild("logoImg") logoImg: any;

	public isLargeImage: Boolean = false;
	private MIN_IMG_WIDTH: number = 100;

	constructor() {}

	ngOnInit() {}
	ngOnChanges(changes: SimpleChange) {
		this.checkImageWidth();
	}
	checkImageWidth() {
		var image = new Image();
		image.addEventListener("load", (e) => this.handleImageLoad(e));
		image.src = this.logoData.docBarLogo;
	}

	handleImageLoad(event) {
		console.log("width ", event.target.width + " height ", event.target.height);
		if (event.target.width > this.MIN_IMG_WIDTH) {
			this.isLargeImage = true;
		}
	}
}
